/**
 * This file was automatically generated by `bwcx-client-vue`.
 * DO NOT MODIFY IT BY HAND.
 */

import { Newable } from 'bwcx-common';
import { RenderMethodKind } from 'bwcx-client-vue/enums';
export const clientRoutesMap = new Map<string, { path: string; routeProps: Newable | undefined; renderMethod: RenderMethodKind | undefined }>([
  ['Home', { path: '/', routeProps: undefined, renderMethod: RenderMethodKind.SSR }],
  ['Releases', { path: '/releases', routeProps: undefined, renderMethod: RenderMethodKind.SSR }],
]);

